<template>
  <Teleport to="body">
    <div v-if="visible" class="ocr-cost-char__mask" @click.self="emit('close')">
      <div class="ocr-cost-char__dialog">
        <button class="ocr-cost-char__close" type="button" @click="emit('close')">×</button>
        <div class="ocr-cost-char__dialog-title">{{ t("ocr_cost_char_title") }}</div>
        <div class="ocr-cost-char__dialog-content">
          <template v-if="isAllPdf">
            <div class="ocr-cost-char__dialog-line">
              {{ t("ocr_cost_char_extra_cost") }}{{ formatNumber(ocrCostWord) }}{{ t("ocr_cost_char_per_page") }}
            </div>
            <div class="ocr-cost-char__dialog-line">
              {{ t("ocr_cost_char_total_pages") }}{{ formatNumber(totalPages) }}{{ t("ocr_cost_char_page_unit") }}
            </div>
            <div class="ocr-cost-char__dialog-line">
              {{ t("ocr_cost_char_total_cost") }}{{ formatNumber(totalCost) }}{{ t("ocr_cost_char_char_unit") }}
            </div>
          </template>
          <template v-else>
            <div v-if="ocrCostWord > 0" class="ocr-cost-char__dialog-line">
              {{ t("ocr_cost_char_extra_cost") }}{{ formatNumber(ocrCostWord) }}{{ t("ocr_cost_char_per_page") }}
            </div>
          </template>
        </div>
        <div class="ocr-cost-char__actions">
          <button class="ocr-cost-char__button ocr-cost-char__button--ghost" type="button" @click="emit('close')">
            {{ t("ocr_cost_char_cancel") }}
          </button>
          <button class="ocr-cost-char__button ocr-cost-char__button--primary" type="button" @click="emit('confirm')">
            {{ t("ocr_cost_char_confirm") }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import { useI18n } from "vue-i18n";

const props = withDefaults(
  defineProps<{
    visible?: boolean;
    isAllPdf?: boolean;
    ocrCostWord?: number;
    totalPages?: number;
    totalCost?: number;
  }>(),
  {
    visible: false,
    isAllPdf: false,
    ocrCostWord: 0,
    totalPages: 0,
    totalCost: 0,
  }
);

const emit = defineEmits<{
  (e: "close"): void;
  (e: "confirm"): void;
}>();

const { t } = useI18n();

const formatNumber = (value: number) => Number(value || 0).toLocaleString();

const { visible, isAllPdf, ocrCostWord, totalPages, totalCost } = toRefs(props);
</script>

<style scoped lang="scss">
.ocr-cost-char__mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.ocr-cost-char__dialog {
  position: relative;
  width: 408px;
  padding: 34px 16px 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.16);
}

.ocr-cost-char__close {
  position: absolute;
  top: 16px;
  right: 20px;
  border: none;
  background: transparent;
  color: #595959;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.ocr-cost-char__dialog-title {
  color: #262626;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  text-align: center;
}

.ocr-cost-char__dialog-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
  color: #595959;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.ocr-cost-char__dialog-line {
  white-space: nowrap;
}

.ocr-cost-char__actions {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}

.ocr-cost-char__button {
  flex: 1;
  height: 36px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  height: 40px;
}

.ocr-cost-char__button--ghost {
  border: 1px solid #d9d9d9;
  background: #ffffff;
  color: #595959;
}

.ocr-cost-char__button--primary {
  border: 1px solid #2590e1;
  background: #2590e1;
  color: #ffffff;
}
</style>
